import React, { FC } from 'react';

import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import CloseIcon from '../../../assets/icons/CloseIcon';
import NotificationFabric from '../../../pages/DashboardPage/components/Notifications/NotificationFabric';
import styled from '../../../styled';
import {
  colorsPalette,
  MIDDLE_MARGIN_PX,
  MIDDLE_RADIUS_PX,
  SMALL_MARGIN_PX,
  SMALL_RADIUS_PX,
  SUBMIDDLE_MARGIN_PX,
  TINY_MARGIN_PX,
} from '../../../theme';
import { AnnouncementEntity } from '../../../types';

interface INotifications {
  items?: AnnouncementEntity[];
  fetchMore: () => void;
  disabledPagination: boolean;
  closeHandler: () => void;
}

const Notifications: FC<INotifications> = ({
  items,
  fetchMore,
  disabledPagination,
  closeHandler,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Row>
        <Title>{t('page.dashboard.notifications')}</Title>
        <StyledCloseIcon onClick={closeHandler} />
      </Row>
      <List>
        {items?.map((item) => (
          <NotificationFabric item={item} />
        ))}
        <ViewMore disabled={disabledPagination} onClick={fetchMore}>
          {t('button.viewMore')}
        </ViewMore>
      </List>
    </Wrapper>
  );
};

export default Notifications;

const Row = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 ${TINY_MARGIN_PX} ${SMALL_MARGIN_PX};

  ${({ theme }) => theme.breakpoints.up('md')} {
    display: none;
  }
`;
const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-height: calc(100vh - 60px);
  margin: 0 0 0 -${MIDDLE_MARGIN_PX};
  padding: ${SUBMIDDLE_MARGIN_PX} ${TINY_MARGIN_PX} ${MIDDLE_MARGIN_PX} ${TINY_MARGIN_PX};
  background: ${colorsPalette.blueDark};

  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 600px;
    margin: 0 0 0 -${MIDDLE_MARGIN_PX};
    padding: ${MIDDLE_MARGIN_PX} ${SMALL_MARGIN_PX} ${MIDDLE_MARGIN_PX}
      calc(${MIDDLE_MARGIN_PX} - ${TINY_MARGIN_PX});
    border-radius: ${MIDDLE_RADIUS_PX};
    background: ${colorsPalette.blackSecondary};
    box-shadow: 0 13px 26px ${alpha(colorsPalette.blackPure, 0.33)};
  }
`;
const List = styled('ul')`
  max-height: 100%;
  list-style-type: none;
  padding: 0 ${TINY_MARGIN_PX};
  margin: 0;
  overflow-y: auto;

  ${({ theme }) => theme.breakpoints.up('md')} {
    max-height: 440px;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 18px 18px ${alpha(colorsPalette.blue, 0.33)};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    box-shadow: inset 0 0 18px 18px ${colorsPalette.blue};
  }
`;
const ViewMore = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;
  width: 100%;
  margin-top: ${SMALL_MARGIN_PX};
  background: ${colorsPalette.violetAnalyticsCard};
  color: ${colorsPalette.gray};
  font-weight: 700;
  border-radius: ${SMALL_RADIUS_PX};
  border: none;
  pointer-events: ${({ disabled }) => disabled && 'none'};
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  opacity: ${({ disabled }) => disabled && '0.3'};
`;
const Title = styled('span')`
  display: block;
  font-weight: 700;
`;
const StyledCloseIcon = styled(CloseIcon)`
  width: 14px;
  height: 14px;
`;
